import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6b0732c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-e6b0732c><div class=\"col-8 offset-2\" data-v-e6b0732c><h1 class=\"h1 text-center\" data-v-e6b0732c>Přidej se k nám</h1></div></div><div class=\"row\" data-v-e6b0732c><div class=\"col-md-8 col-sm-10 offset-md-2 offset-sm-0\" data-v-e6b0732c><p class=\"text-justify\" data-v-e6b0732c> Nejlepší čas na to přidat se do závodního týmu je začátek sezóny, tedy v průběhu dubna, května nebo června. Je však možné se přidat kdykoli v jejím průběhu. </p><p class=\"text-justify\" data-v-e6b0732c> Aby mohl tým kvalitně trénovat, je důležitá účast každého bruslaře na každém tréninku. Týmy všech věkových kategorií, včetně přípravného kurzu, trénují několikrát týdně, a to jak na ledě, tak v tělocvičně. Ta je pro synchronizované bruslení důležitá nejen jako fyzická příprava, ale také pro nacvičení a sjednocení choreografií. </p><p class=\"text-center\" data-v-e6b0732c><a href=\"https://www.youtube.com/watch?v=i2hplCYTeQk\" title=\"Reportáž\" class=\"btn kometa-btn kometa-primary-bg\" data-v-e6b0732c>Zkoukni co je synchronizované bruslení</a></p></div></div>", 2)
const _hoisted_5 = { class: "row mt-5" }
const _hoisted_6 = { class: "col-8 offset-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-8 offset-2" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "h2 text-center" }, "Vyber si z našich týmů")
  ])
], -1))
const _hoisted_8 = { class: "col-md-8 col-sm-12 offset-md-2 offset-sm-0" }
const _hoisted_9 = { class: "text-center mb-5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Kontakty na trenéry jednotlivých týmu")
const _hoisted_11 = { class: "row row-cols-lg-5 row-cols-md-2 row-cols-1 gx-5" }
const _hoisted_12 = { class: "col mb-4" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<img src=\"/assets/join-us/join-us-juniorky.jpg\" class=\"card-img-top\" alt=\"Juniorky\" data-v-e6b0732c><div class=\"card-body\" data-v-e6b0732c><p class=\"text-center\" data-v-e6b0732c><span class=\"badge rounded-pill kometa-juniorky-bg\" data-v-e6b0732c>Juniorky</span></p><p class=\"text-center mb-0\" data-v-e6b0732c>Hlavní trenérka:</p><p class=\"text-center\" data-v-e6b0732c>Klaudie Palkosková</p><p class=\"text-center small fw-bold\" data-v-e6b0732c> Přijímáme zkušené krasobruslařky ve věku 13-18 let. </p></div>", 2)
const _hoisted_15 = [
  _hoisted_13
]
const _hoisted_16 = { class: "col mb-4" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<img src=\"/assets/join-us/join-us-mixed-age.jpg\" class=\"card-img-top\" alt=\"Přípravka\" data-v-e6b0732c><div class=\"card-body\" data-v-e6b0732c><p class=\"text-center\" data-v-e6b0732c><span class=\"badge rounded-pill kometa-mixed-age-bg\" data-v-e6b0732c>Mixed Age</span></p><p class=\"text-center mb-0\" data-v-e6b0732c>Hlavní trenérka:</p><p class=\"text-center\" data-v-e6b0732c>Lucia Stopková</p><p class=\"text-center small fw-bold\" data-v-e6b0732c> Přijímáme krasobruslaře starší 13 let. </p></div>", 2)
const _hoisted_19 = [
  _hoisted_17
]
const _hoisted_20 = { class: "col mb-4" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<img src=\"/assets/join-us/join-us-zacky.jpg\" class=\"card-img-top\" alt=\"Žačky\" data-v-e6b0732c><div class=\"card-body\" data-v-e6b0732c><p class=\"text-center\" data-v-e6b0732c><span class=\"badge rounded-pill kometa-zacky-bg\" data-v-e6b0732c>Žačky</span></p><p class=\"text-center mb-0\" data-v-e6b0732c>Hlavní trenérka:</p><p class=\"text-center\" data-v-e6b0732c>Klaudie Palkosková</p><p class=\"text-center small fw-bold\" data-v-e6b0732c> Přijímáme krasobruslařky ve věku 9 – 13 let. </p></div>", 2)
const _hoisted_23 = [
  _hoisted_21
]
const _hoisted_24 = { class: "col mb-4" }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<img src=\"/assets/join-us/join-us-mladsi-zacky.jpg\" class=\"card-img-top\" alt=\"Mladší žačky\" data-v-e6b0732c><div class=\"card-body\" data-v-e6b0732c><p class=\"text-center\" data-v-e6b0732c><span class=\"badge rounded-pill kometa-mladsi-zacky-bg\" data-v-e6b0732c>Mladší žačky</span></p><p class=\"text-center mb-0\" data-v-e6b0732c>Hlavní trenérka:</p><p class=\"text-center\" data-v-e6b0732c>Jana Ficová</p><p class=\"text-center small fw-bold\" data-v-e6b0732c> Přijímáme krasobruslařky ve věku 6-9 let nebo děti do 10 let, které již absolvovaly oddílový nábor USK Praha nebo jiný kurz bruslení a zvládají základy bruslení. </p></div>", 2)
const _hoisted_27 = [
  _hoisted_25
]
const _hoisted_28 = { class: "col mb-4" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<img src=\"/assets/join-us/join-us-pripravka.jpg\" class=\"card-img-top\" alt=\"Přípravka\" data-v-e6b0732c><div class=\"card-body\" data-v-e6b0732c><p class=\"text-center\" data-v-e6b0732c><span class=\"badge rounded-pill kometa-pripravka-bg\" data-v-e6b0732c>Přípravka</span></p><p class=\"text-center mb-0\" data-v-e6b0732c>Hlavní trenérka:</p><p class=\"text-center\" data-v-e6b0732c>Jana Ficová</p><p class=\"text-center small fw-bold\" data-v-e6b0732c> Přijímáme děti ve věku 5-8 let (začátečníky nebo mírně pokročilé). </p></div>", 2)
const _hoisted_31 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_contact_form = _resolveComponent("contact-form")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_contact_form)
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", _hoisted_9, [
          _createVNode(_component_router_link, { to: { name: 'coachTeam' } }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectTeam('juniorky')), ["prevent"])),
            class: "card h-100"
          }, _hoisted_15)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectTeam('pripravka')), ["prevent"])),
            class: "card h-100"
          }, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.selectTeam('zacky')), ["prevent"])),
            class: "card h-100"
          }, _hoisted_23)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.selectTeam('mladsi-zacky')), ["prevent"])),
            class: "card h-100"
          }, _hoisted_27)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.selectTeam('pripravka')), ["prevent"])),
            class: "card h-100"
          }, _hoisted_31)
        ])
      ])
    ])
  ]))
}